import React, { useEffect } from 'react'
import Close from '../../assets/Close.tsx'
import './Drawer.scss'

export const Drawer = ({ isOpened, onClose, children }) => {
    useEffect(() => {
        const rootElement = document.documentElement
        const bodyElement = document.body

        if (!isOpened) {
            rootElement.classList.remove('drawer-scroll-locked')
            bodyElement.classList.remove('drawer-scroll-locked')
            return
        }

        rootElement.classList.add('drawer-scroll-locked')
        bodyElement.classList.add('drawer-scroll-locked')

        return () => {
            rootElement.classList.remove('drawer-scroll-locked')
            bodyElement.classList.remove('drawer-scroll-locked')
        }
    }, [isOpened])

    return (
        <div className={`drawerShell ${isOpened ? 'drawerShell--opened' : ''}`}>
            <button
                aria-label="Zamknij szuflade testow"
                className={`drawer__overlay ${isOpened ? 'drawer__overlay--opened' : ''}`}
                onClick={onClose}
                type="button"
            />
            <div
                aria-hidden={!isOpened}
                className={`drawer ${isOpened ? '' : 'drawer--closed'}`}
                role="dialog"
            >
                <div className="drawer__close-wrapper">
                    <button
                        className="drawer__close"
                        onClick={onClose}
                        type="button"
                    >
                        <Close />
                    </button>
                </div>
                {children}
            </div>
        </div>
    )
}
